// src/features/game/components/bottomsheets/EarnPointInfoSheet.tsx
import React from 'react';
import { AlertCircle, Star } from 'lucide-react';

interface EarnPointInfoSheetProps {
  currentPoints: number;
  requiredPoints: number;
  onConfirm: () => void;
  onEarnMore: () => void;
}

export const EarnPointInfoSheet: React.FC<EarnPointInfoSheetProps> = ({
  currentPoints,
  requiredPoints,
  onConfirm,
  onEarnMore,
}) => {
  return (
    <div className="p-6 space-y-6">
      {/* 타이틀 */}
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-2 text-red-500">
          {/* <Gift className="w-5 h-5" /> */}
          <span className="text-sm font-semibold">현재획득 {currentPoints}일차</span>
        </div>
        <h2 className="text-xl font-bold">별 포인트 1개</h2>
      </div>

      {/* 캐릭터 */}
      <div className="flex justify-center">
        <img src="/characters/happy-bear.png" alt="행복한 캐릭터" className="w-32 h-32" />
      </div>

      {/* 안내 문구 */}
      <p className="text-center text-gray-600">
        안녕! 오늘도 반짝이는
        <br />
        하루를 만들어 보자 ^^
      </p>

      {/* 경고 메시지 */}
      <div className="flex gap-3 p-4 bg-red-50 rounded-lg">
        <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-red-600">
          <strong>알아두세요!</strong>
          <br />
          하루에 1개만 가능해요.
          <br />별 포인트 10개를 사용하여 문제풀이를 다 할 수 있어요
        </div>
      </div>

      {/* 버튼 그룹 */}
      <div className="space-y-3">
        <button
          onClick={onConfirm}
          className="w-full py-4 bg-cyan-500 text-white font-bold rounded-xl hover:bg-cyan-600 transition-colors"
        >
          확인
        </button>
        <button
          onClick={onEarnMore}
          className="w-full py-4 bg-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-300 transition-colors"
        >
          오늘 그만 보기
        </button>
      </div>
    </div>
  );
};
